import * as React from 'react';
import * as PropTypes from 'prop-types';
import ReactTable from 'react-table';
import cn from 'classnames';
import { get, isEmpty } from 'lodash';

import { ChecksThComponent } from 'components/ReactTableComponent/components/ThCustom/ThCustom';
import { ChecksLoadingComponent } from 'components/ReactTableComponent/components/LoadingComponent/LoadingComponent';
import PaginationComponent from 'components/ReactTableComponent/components/CustomPaginationComponent/CustomPaginationComponent';
import LimitedFooterComponent from 'components/ReactTableComponent/components/LimitedFooterComponent/LimitedFooterComponent';
import { TdCustom } from 'components/ReactTableComponent/components/TdCustom/TdCustom';

import 'react-table/react-table.css';
import './style.scss';
import Button from 'components/Button';

export default class ReactTableComponent extends React.Component {
  state = {
    rowToDisplay: this.props.rowLimit,
    columns: this.props.columns,
    isFirstColumnFtTaken: get(this.props.columns, '[0].Footer'),
  };

  componentDidMount() {
    this.setShowMoreFooter();
  }

  componentDidUpdate(prevProps, prevState) {
    const { rowToDisplay } = this.state;
    const { columns } = this.props;
    if (rowToDisplay !== prevState.rowToDisplay) {
      this.setShowMoreFooter();
    } else if (columns !== prevProps.columns) {
      this.setColumns();
    }
    if (prevProps.rowLimit !== this.props.rowLimit) {
      this.setRowToDisplay();
    }
  }

  setColumns() {
    const { columns } = this.props;
    this.setState({ columns });
  }

  setRowToDisplay = () => {
    this.setState({ rowToDisplay: this.props.rowLimit });
  };

  setShowMoreFooter = () => {
    const { tableData, columns } = this.props;
    const { rowToDisplay, isFirstColumnFtTaken } = this.state;
    if (rowToDisplay < tableData.length && !isFirstColumnFtTaken) {
      const firstColumn = Object.assign({}, columns[0]);
      firstColumn.Footer = (
        <Button
          onClick={this.showMoreHandle}
          type={'button'}
          isLinkStyled={true}
          hasWrapper={false}
        >
          Показать ещё
        </Button>
      );
      return this.setState({ columns: [firstColumn, ...columns.slice(1)] });
    }
    this.setState({ columns });
  };

  showMoreHandle = () => {
    const { rowToDisplay } = this.state;
    const { showNextQuantityRow } = this.props;
    this.setState({ rowToDisplay: rowToDisplay + showNextQuantityRow });
  };

  getTfootProps = () => {
    const { tableData } = this.props;
    const { rowToDisplay, isFirstColumnFtTaken } = this.state;
    return {
      showMore: this.showMoreHandle,
      rowCount: tableData.length,
      currentLimit: rowToDisplay,
      isFirstColumnFtTaken,
    };
  };

  handleFetchData = () => {};

  render() {
    const {
      tableData,
      paginationOptions,
      isLoading,
      fetchNextPage,
      defaultFiltered,
      defaultSorted,
      sorted,
      manual,
      onSortedChange,
      sortable,
      CustomThComponent,
      CustomPaginationComponent,
      CustomLoadingComponent,
      CustomFooterComponent,
      theme,
      TdCustomComponent,
      showPaginationSizeInput,
      getTrProps,
      pageSizeOptions,
      className,
      defaultPageSize,
    } = this.props;

    return (
      <ReactTable
        className={className}
        columns={this.state.columns}
        data={tableData}
        sortable={sortable}
        filterable={false}
        paginationOptions={paginationOptions}
        fetchNextPage={fetchNextPage}
        pageSize={this.state.rowToDisplay}
        defaultFiltered={defaultFiltered}
        defaultSorted={defaultSorted}
        sorted={sorted}
        manual={manual}
        onSortedChange={onSortedChange}
        resizable={false}
        minRows={0}
        ThComponent={CustomThComponent}
        TdComponent={TdCustomComponent}
        PaginationComponent={CustomPaginationComponent}
        LoadingComponent={CustomLoadingComponent}
        TfootComponent={CustomFooterComponent}
        getTfootProps={this.getTfootProps}
        NoDataComponent={() => null}
        loading={isLoading}
        onFetchData={this.handleFetchData}
        showPaginationBottom={!isEmpty(paginationOptions)}
        showPaginationSizeInput={showPaginationSizeInput}
        getTrProps={getTrProps}
        pageSizeOptions={pageSizeOptions}
        defaultPageSize={defaultPageSize}
      >
        {/* eslint-disable-next-line no-unused-vars */}
        {({ filtered }, makeTable) => {
          return (
            <div
              className={cn([
                `tableTheme_${theme}`,
                'ReactTableWrapper',
                className,
                {
                  ReactTable__noChild: !this.props.children,
                },
              ])}
            >
              {this.props.children}

              <div className={'ChecksTable__content'}>{makeTable()}</div>
            </div>
          );
        }}
      </ReactTable>
    );
  }
}
ReactTableComponent.propTypes = {
  manual: PropTypes.bool,
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object),
  sortable: PropTypes.bool,
  paginationOptions: PropTypes.shape({
    number: PropTypes.number,
    size: PropTypes.number,
    sort: PropTypes.array,
    totalPages: PropTypes.number,
  }),
  fetchNextPage: PropTypes.func,
  defaultFiltered: PropTypes.array,
  defaultSorted: PropTypes.array,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  rowLimit: PropTypes.number,
  showNextQuantityRow: PropTypes.number,
  CustomThComponent: PropTypes.func,
  CustomPaginationComponent: PropTypes.func,
  CustomLoadingComponent: PropTypes.func,
  CustomFooterComponent: PropTypes.func,
  TdCustomComponent: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'blue']),
  showPaginationSizeInput: PropTypes.bool,
  getTrProps: PropTypes.func,
  pageSizeOptions: PropTypes.array,
  className: PropTypes.string,
  defaultPageSize: PropTypes.number,
};

ReactTableComponent.defaultProps = {
  sortable: false,
  CustomThComponent: ChecksThComponent,
  TdCustomComponent: TdCustom,
  CustomPaginationComponent: PaginationComponent,
  CustomLoadingComponent: ChecksLoadingComponent,
  CustomFooterComponent: LimitedFooterComponent,
  theme: 'light',
  showNextQuantityRow: 10,
  showPaginationSizeInput: false,
  className: '',
  defaultPageSize: 20,
};
